import { publisherFontAwesomeIconsEnum } from 'common/constants/fontAwesomeConst'
import { PaddingType } from 'common/types/styleTypes'
import React from 'react'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import { BorderEntityInterface } from 'src/shared/schemas/border.schema'
import WebinarSessionDateTimeIconNewUi from './ui/WebinarSessionDateTimeIconNewUi'
import WebinarSessionDateTimeNewUi from './ui/WebinarSessionDateTimeNewUi'

type WebinarSessionDateTimeNewProps = BorderEntityInterface & {
  fontFamily?: string
  fontStyle?: string
  fontWeight?: string
  fontSize: number
  iconFontSize: number
  boxShadow?: string
  padding?: PaddingType
  backgroundColor?: string
  color?: string
  mobileColor?: string
  mobileBackgroundColor?: string
  mobilePadding?: Partial<PaddingType>
  mobileBoxShadow?: string
  mobileIconFontSize?: number
  mobileFontSize?: number
  mobileFontFamily?: string
  mobileFontStyle?: string
  mobileFontWeight?: string
  timestamp?: number
  attrId: string
}
const WebinarSessionDateTimeNew = ({
  fontFamily,
  fontStyle,
  fontWeight,
  fontSize,
  iconFontSize,
  boxShadow,
  padding,
  backgroundColor,
  color,
  border,
  mobileBorder,
  mobileColor,
  mobileBackgroundColor,
  mobilePadding,
  mobileBoxShadow,
  mobileIconFontSize,
  mobileFontSize,
  mobileFontFamily,
  mobileFontStyle,
  mobileFontWeight,
  timestamp,
  attrId,
}: WebinarSessionDateTimeNewProps) => {
  const { t, i18n } = useTypedTranslation('common')
  const date = new Intl.DateTimeFormat(i18n.language, {
    timeStyle: 'short',
    dateStyle: 'long',
  })
  const dateTimeString = date.format(timestamp ? timestamp : Date.now())
  return (
    <WebinarSessionDateTimeNewUi
      id={attrId}
      fontFamily={fontFamily}
      fontStyle={fontStyle}
      fontWeight={fontWeight}
      fontSize={fontSize}
      boxShadow={boxShadow}
      padding={padding}
      backgroundColor={backgroundColor}
      color={color}
      border={border}
      mobileBorder={mobileBorder}
      mobileColor={mobileColor}
      mobileBackgroundColor={mobileBackgroundColor}
      mobilePadding={mobilePadding}
      mobileBoxShadow={mobileBoxShadow}
      mobileFontSize={mobileFontSize}
      mobileFontFamily={mobileFontFamily}
      mobileFontStyle={mobileFontStyle}
      mobileFontWeight={mobileFontWeight}
    >
      <WebinarSessionDateTimeIconNewUi
        className={publisherFontAwesomeIconsEnum.ClockRegular}
        fontSize={iconFontSize}
        mobileFontSize={mobileIconFontSize}
      />
      <span>
        {t('components.webinar_registration_date_time.schedule_training')}
      </span>
      <span>{dateTimeString}</span>
    </WebinarSessionDateTimeNewUi>
  )
}

export default WebinarSessionDateTimeNew
